export function SiteFooter() {
  return (
    <footer className="text-muted-foreground border-t py-6 text-center text-sm">
      <p>Jumpdle is an unofficial fan-made guessing game.</p>
    </footer>
  )
}
